var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgRetry = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93863 14.2122V15.1496C8.93863 15.421 9.23859 15.5936 9.47598 15.4456L12.038 13.8668C12.2629 13.7311 12.2629 13.4105 12.038 13.2748L9.48848 11.7083C9.251 11.5603 8.95113 11.733 8.95113 12.0043V12.9417H8.92611C6.78896 12.9047 5.02683 11.1533 5.01434 9.04402C4.98932 6.76214 6.93893 4.92429 9.27604 5.08464C11.2006 5.20802 12.7879 6.72513 12.9753 8.62465C13.0753 9.62372 12.8004 10.5488 12.2629 11.2889C12.1379 11.4616 12.188 11.6959 12.3754 11.807L12.8628 12.0906C13.0253 12.1893 13.2378 12.1399 13.3502 11.9919C13.9501 11.1532 14.3 10.1295 14.3 9.01932C14.3 6.0097 11.713 3.59213 8.61358 3.81415C6.00157 3.9993 3.91468 6.05925 3.71449 8.60017C3.48958 11.6468 5.91406 14.1877 8.93852 14.2124L8.93863 14.2122Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgRetry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/retry.7f9b5552a97da7781156da503ea53bbb.svg";